var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDiners = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 32,
  height: 24,
  fill: "none",
  ref: ref
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 32,
  height: 24,
  fill: "#0079BE",
  rx: 4
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M17.224 6.001c3.438-.053 6.232 2.728 6.286 6.151v.054c-.108 3.37-2.848 6.098-6.286 6.098H15.02c-3.331-.054-6.018-2.782-6.018-6.098-.107-3.316 2.472-6.098 5.75-6.205zm-2.042 1.07c-2.794 0-5.105 2.3-5.105 5.081s2.311 5.081 5.105 5.081 5.104-2.3 5.104-5.08c0-2.782-2.31-5.083-5.104-5.083m-.806 8.504a3.515 3.515 0 0 1-2.525-4.28 3.53 3.53 0 0 1 2.525-2.514zm1.612-6.794c1.88.482 3.062 2.354 2.579 4.226a3.49 3.49 0 0 1-2.58 2.568z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgDiners);
export default ForwardRef;